import * as React from 'react';

interface BonusBalanceSectionProps {
  bonus: string;
  planName: string;
}

export const BonusBalanceSection = ({ bonus, planName }: BonusBalanceSectionProps) => (
  <div className="bonus-balance">
    <span className="bold-800">
      {`Bonus ${bonus}`}
      &nbsp;
      <span className="underline bold-800">balance</span>
    </span>
    &nbsp;
    {`to account when you sign up with ${planName}`}
  </div>
);
